var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arts-container"},[_c('pageHeader',{staticClass:"page-header"}),_c('div',{staticClass:"content-body w1200"},[_c('div',{staticClass:"page-content"},[_c('router-view')],1)]),_c('pageFooter',{staticClass:"page-footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }